import { createContext } from 'react';

// create useContext
const PendingBidBoxFooterContext = createContext({
  negotiationButtonVariant: null,
  negotiationState: null
});

export default PendingBidBoxFooterContext;
